/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import { EuiFieldSearch } from '@elastic/eui'

import genericMessages from '@modules/project-lib/genericMessages'
import { useQueryStringParams } from '@modules/utils/qs'

import { filterSchema } from './schema'

const ProjectIdFilter: React.FunctionComponent = () => {
  const { formatMessage } = useIntl()

  const { setQueryStringItem, queryStringItems } = useQueryStringParams(filterSchema.parse)

  const [query, setQuery] = useState(queryStringItems.project_id || '')

  return (
    <EuiFieldSearch
      style={{ width: '24rem' }}
      aria-label={formatMessage(genericMessages.projectId)}
      placeholder={formatMessage(genericMessages.projectId)}
      onBlur={() => setProjectId(query)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          setProjectId(query)
        }
      }}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
    />
  )

  function setProjectId(s: string) {
    setQueryStringItem('project_id', s || null)
  }
}

export default ProjectIdFilter
